export const arrayAverage = (arr) => arr.reduce((a, b) => a + b, 0) / (arr.length || 1);
